import { CSVIcon } from '@/components/icons/csv-icon'
import { TableIcon } from '@/components/icons/table-icon'
import { UploadIcon } from '@/components/icons/upload-icon'
import { TooltipIconButton } from '@/components/ui/tooltip-icon-button'
import { type TurnInputAttachment } from '@/hooks/api/use-turn-status-query'
import { cn } from '@/lib/utils'
import { T, useTranslate } from '@tolgee/react'
import { ChevronDown } from 'lucide-react'
import React from 'react'

type MessageInputAttachmentsProps = {
  inputAttachments: TurnInputAttachment[]
}

function MessageInputAttachments({ inputAttachments }: MessageInputAttachmentsProps) {
  const { t } = useTranslate()
  const [expanded, setExpanded] = React.useState(true)
  return (
    <div className='w-full break-words rounded-lg border border-neutral-75 bg-neutral-25'>
      <div
        className={cn(
          'flex w-full items-center justify-between gap-2 p-2',
          expanded && 'border-b border-b-neutral-75',
        )}
      >
        <div className='flex items-center gap-1'>
          <UploadIcon className='rounded-full bg-mango-50 text-mango-300' />
          <span className='font-neue-machina text-sm font-normal'>
            <T keyName='chat.attachments.title' />
          </span>
        </div>

        <TooltipIconButton
          size={'xs'}
          titleString={expanded ? t('chat.attachments.collapse') : t('chat.attachments.expand')}
          onClick={() => setExpanded(!expanded)}
        >
          <ChevronDown className={cn('transition-transform', expanded && 'rotate-180')} />
        </TooltipIconButton>
      </div>
      <div
        style={{ maxHeight: expanded ? inputAttachments.length * 320 + 32 : 0 }}
        className={cn(
          'overflow-hidden transition-[max-height,opacity] ease-in-out',
          expanded ? 'opacity-100' : 'opacity-0',
        )}
      >
        <div className='flex flex-col gap-1.5 px-3 py-2'>
          {inputAttachments.map((attachment) => (
            <div key={attachment.fileId} className='flex items-center gap-1'>
              {attachment.fileName.endsWith('.csv') && <CSVIcon />}
              {attachment.fileName.endsWith('.xlxs') && <TableIcon />}
              <p title={attachment?.fileName} className='truncate text-xs font-light'>
                {attachment?.fileName}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export { MessageInputAttachments }
